import DeviceLookup from './DeviceLookup';

export default DeviceLookup;
